import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { arrancarIdioma } from "./i18n";
import Reventon, { mirarLosOtrosErrores } from "./Reventon";

/* ⚠️  EL IDIOMA SE RESUELVE ANTES DEL PRIMER PINTADO, Y ESA PALABRA
 *     —ANTES— ES TODA LA LÍNEA.
 *
 * `<html lang>` y `<html dir>` tienen que estar puestos cuando React
 * dibuja por primera vez. Si se hicieran dentro de un `useEffect`, el
 * primer cuadro saldría con `dir="ltr"` y alguien que dejó la app en
 * árabe vería la pantalla entera saltar de lado. Y `lang` no es
 * decorativo: de él dependen el corrector del navegador, el lector de
 * pantalla, y qué fuente elige el sistema para el chino contra el
 * japonés.
 *
 * Devuelve el idioma que quedó: el que la persona eligió alguna vez, o
 * inglés si nunca eligió ninguno. Ver src/i18n.js. */
arrancarIdioma();

/* Los errores que el ErrorBoundary no puede ver —los de un onClick, un
 * setTimeout, una promesa rechazada— al menos quedan en la consola con
 * marca. Ver src/Reventon.js. */
mirarLosOtrosErrores();

/* ⚠️  `Reventon` VA POR FUERA DE `<App />`, Y ESO ES TODO EL PUNTO.
 *
 * Un ErrorBoundary solo atrapa lo que revienta ABAJO suyo en el árbol.
 * Puesto adentro de App —por ejemplo alrededor de las pestañas— no
 * vería un error del propio App, del AuthProvider ni del Login, que es
 * justo donde estuvo el que dejó la pantalla en blanco el 5/9.
 *
 * Adentro de StrictMode y no afuera: StrictMode no atrapa nada, solo
 * avisa, y en desarrollo vuelve a lanzar el error después de que el
 * boundary lo atrapó — así que en `npm start` se ve el overlay de CRA
 * igual, que es lo que uno quiere mientras programa. En producción no
 * hay overlay y manda el cartel. */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Reventon>
      <App />
    </Reventon>
  </React.StrictMode>
);
